import {HttpClient} from '@angular/common/http';
import {Injectable, OnInit} from '@angular/core';
import {environment} from '../../environments/environment';
import {
  ReturnDetails,
  ContainersList,
  ContainerPostBody,
  ReturnDetailsRequest,
} from '../models/return-container-reference';
import {BehaviorSubject, Observable} from 'rxjs';
import {ApiRoutes} from "./apiroutes";
import { BackendListModel } from '../models/common/list.model';

@Injectable({
  providedIn: 'root',
})
export class ReturnContainersService implements OnInit {
  API_URL = `${environment.baseApiUrl}/api/booking/pickup_based_return_container_reference/`;
  return_details_url = `${environment.baseApiUrl}/api/booking/container_pickup_list/`;
  save_return_url = `${environment.baseApiUrl}/api/booking/return_container_update/`;
  return_details_request_url = `${environment.baseApiUrl}/api/booking/return_details_request/`;
  container_url = ApiRoutes.ContainerMaster;
  booking_url = ApiRoutes.LeadRequest;
  pudo_url=`${environment.baseApiUrl}/api/booking/pickup_dropoff_details/`;
  base_url3 = ApiRoutes.DepotMaster

  private _containerSubject$ = new BehaviorSubject<ReturnDetails[]>([]);

  containerSubject$ = this._containerSubject$.asObservable();

  constructor(private http: HttpClient) {
  }

  ngOnInit() {
  }

  getAllContainerDetails(request_id: string) {
    return this.http.get<ReturnDetails[]>(this.API_URL + request_id + '/');
  }
  // getAllContainerDetails(request_id: string, page_size = 10, page = 1, search = '', order = ''): Observable<ReturnDetails[]> {
  //   let url = `${this.API_URL}${request_id}/`;
  //   let urlObj = new URL(url);
  //   urlObj.searchParams.append('page_size', String(page_size));
  //   urlObj.searchParams.append('page', String(page));
  //   urlObj.searchParams.append('search', String(search));
  //   urlObj.searchParams.append('o', String(order));

  //   return this.http.get<ReturnDetails[]>(String(urlObj));
  // }

  getReturnDetailsbyRequestId(request_id: string) {
    return this.http.get<ContainersList[]>(
      this.return_details_url + request_id + '/'
    );
  }

  getReturnContainersList(returnId: string, type?: string) {
    let url = '';
    url = `${this.return_details_url}request_containers/${returnId}/?is_marked_in_return_reference=false` + (type == 'arcon' ? '&do_owner=' + type + '' : '');
    return this.http.get<ContainersList[]>(url);
  }

  saveReturnDetails(
    containers: string[],
    dropDate: string,
    remarks: string,
    returnId: string,
    port:string
  ) {
    console.log('booking/return_container_update');
    return this.http.post(this.save_return_url + returnId + '/', {
      containers: containers,
      dropoff_date: dropDate,
      remarks: remarks,
      port:port
    });
  }

  getReturnDetailsRequest(request_id: string) {
    return this.http.get<ReturnDetailsRequest>(
      this.return_details_request_url + request_id + '/'
    );
  }

  // getReexportedContainersList(requestId: string) {
  //   let url = `${this.booking_url}container_reexport_details/` + requestId + '/';
  //   return this.http.get<any[]>(url);
  // }
  getReexportedContainersList(page_size = 10, page = 1, search = '', order = '',requestId=''): Observable<BackendListModel<any>> {
    let url = `${this.booking_url}container_reexport_details/` + requestId + '/';
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    urlObj.searchParams.append('search', String(search));
    urlObj.searchParams.append('o', String(order));
    return this.http.get<BackendListModel<any>>(String(urlObj));
  }

  postReexportedContainersList(requestId: string, containerDetails: any) {
    let url = `${this.booking_url}container_reexport_details/` + requestId + '/';
    return this.http.post<[]>(url, containerDetails);
  }

  putReexportedContainersList(requestId: string, containerDetails: any) {
    let url = `${this.booking_url}container_reexport_details/` + requestId + '/'  +containerDetails.id+ '/';
    return this.http.put<[]>(url, containerDetails);
  }

  deleteReexportedContainersList(requestId: string, containerDetails: any) {
    let url = `${this.booking_url}container_reexport_details/` + requestId + '/'  +containerDetails.id + '/';
    return this.http.delete<[]>(url, containerDetails);
  }

  getPickupDropoffContainerDetails(request_id: string) {
    return this.http.get<ReturnDetails[]>(this.pudo_url + request_id + '/');
  }
  //getPortsbyDepotId
  getPortsByLocationId(depot_id): Observable<BackendListModel<any>> {
    let url = `${this.base_url3}location/?depot_id=${depot_id}`;
    return this.http.get<BackendListModel<any>>(url);
  }
}
